module.exports = "<template> <div ref=container></div> </template> ";